import { IonApp, IonButton, IonContent, IonPage, IonPopover, IonRouterOutlet, setupIonicReact } from '@ionic/react';
import { IonReactRouter } from '@ionic/react-router';
/* Core CSS required for Ionic components to work properly */

import '@ionic/react/css/core.css';
import '@ionic/react/css/display.css';
import '@ionic/react/css/flex-utils.css';
import '@ionic/react/css/float-elements.css';
/* Basic CSS for apps built with Ionic */
import '@ionic/react/css/normalize.css';
/* Optional CSS utils that can be commented out */
import '@ionic/react/css/padding.css';
import '@ionic/react/css/structure.css';
import '@ionic/react/css/text-alignment.css';
import '@ionic/react/css/text-transformation.css';
import '@ionic/react/css/typography.css';
import { useEffect, useRef, useState } from 'react';
import { Redirect, Route } from 'react-router-dom';
import './App.scss';

import InitPsReset from './features/authentication/InitPsReset';
import NewPs from './features/authentication/NewPs';
import Signin from './features/authentication/Signin';
import Signup from './features/authentication/Signup';
import Dashboard from './features/Dashboard';
import About from './features/documents/About';
import ConfidentialPol from './features/documents/ConfidentialPolicy';
import Faq from './features/documents/Faq';
import LegalNotice from './features/documents/LegalNotice';
import UserTermsP from './features/documents/UserTerms';
import TransactionFailure from './features/donations_and_credit/TransactionFailure';
import TransactionSuccess from './features/donations_and_credit/TransactionSuccess';
import Home from './features/Home';
import NotFoundPage from './features/NotFound';
import Organizations from './features/organizations/Organizations';
import Orgdetail from './features/organizations/OrgDetail';
import SwFundraiser from './features/sw_fundraising/SwFundraiser';
import SwFundraiserCreditPay from './features/sw_fundraising/SwFundraiserCreditPay';
import SwFundraiserDonateStart from './features/sw_fundraising/SwFundraiserDonateStart';
import { Account, User } from "./models/data";
import AuthServ from "./services/auth";
import { retrieveLanguage, storeLanguage } from './services/language_service';
//import { getLastUrl, storeCurrentUrl } from './services/navigation_service';
/* Theme variables */
import Header from './components/Header';
import LogoutTimer from './features/authentication/LogoutTimer';
import DonateHome from './features/donations_and_credit/DonateHome';
import FundraiserDetail from './features/fundraise/FundraiseDetail';
import FundraiseHome from './features/fundraise/FundraiseHome';
import GiftCardHome from './features/giftcards/giftcardshome';
import { translation } from './models/translation';
import Meta from './components/Meta';
import { AppInfo } from './models/appInfo';
import './theme/variables.css';
import AllNews from './features/news/AllNews';
import News from './features/news/news';

setupIonicReact();

interface AppProps {

}

interface Redirection {
  path: string,
  state: any
}

const App: React.FC<AppProps> = () => {

  let pathname = window.location.pathname;


  const getLan = (pathname: string) => {

    let languages: string[] = ['/de', '/en', '/fr',];

    let siteLanguage: string = '';


    languages.every((lang) => {
      if (pathname.indexOf(lang) === 0) {
        siteLanguage = lang
        return false;
      }
      return true
    });

    if (siteLanguage.length < 1) {
      let localLan = retrieveLanguage()
      if (localLan && localLan.length > 1) {
        siteLanguage = localLan;
      } else {
        siteLanguage = "/fr"
      }
    } else {
      storeLanguage(siteLanguage)
    }

    return siteLanguage;

  }


  const [lan] = useState(getLan(pathname));

  const siteText = translation()

  const popover = useRef<HTMLIonPopoverElement>(null);
  const [popoverOpen, setPopoverOpen] = useState(false);

  const [redirection] = useState<Redirection>({ path: '', state: null });

  const account: Account = {
    feeds: '56'
  };

  const [signedIn, setSignedIn] = useState<boolean>(false);

  const signIn = (value: boolean) => {
    setSignedIn(value);
  }

  const authServ = new AuthServ();

  const [user, setUser] = useState<User | null>(null);
  const [loading, setLoading] = useState('');



  useEffect(() => {
    getUser();

  }, [])


  const handleLogout = async () => {
    await authServ.unSetUser();
    setSignedIn(false);
    removeUser();
    setPopoverOpen(true)
  };


  const getUser = async () => {
    authServ.getUser().then(
      (data) => {
        setUser(data)
        if (data?.email) {
          setSignedIn(true)
        }
        setLoading('done');
      }
    )
    return
  }

  const removeUser = () => {
    setUser(null)
  }


  const refresh = () => {
    getUser()
    setLoading('')
  }

 
  return (

    <IonApp>
      {user && <LogoutTimer timeout={25 * 60 * 1000} onLogout={handleLogout} />}
      <IonReactRouter>
        {loading === 'done' &&

          <IonPage>
            <Meta org={AppInfo} title={AppInfo.slogan} description={AppInfo.slogan} url={window.location.href}></Meta>
            <Header removeUser={removeUser} signIn={signIn} user={user}></Header>
            <div id='popupTriggerRef'></div>

            <IonRouterOutlet>

              <Route exact path={`/`}>
                {
                  redirection.path?.length > 0 ? <Redirect to={{ pathname: `${lan}/${redirection.path}`, state: redirection.state }} /> :
                    <Redirect to={`${lan}/home`} />
                }
              </Route>

              <Route exact path={`${lan}/`}>
                {
                  redirection.path?.length > 0 ? <Redirect to={{ pathname: `${lan}/${redirection.path}`, state: redirection.state }} /> :
                    <Redirect to={`${lan}/home`} />
                }
              </Route>

              <Route path={`${lan}/home`}>
                <Home user={user} lan={lan}></Home>
              </Route >

              <Route path={`${lan}/about_us`}>
                <About />
              </Route>

              <Route path={`${lan}/account`}>
                {user ? <Dashboard lan={lan} removeUser={removeUser} refresh={refresh} user={user} account={account} signIn={signIn} ></Dashboard> : <Redirect to={`${lan}/home`}></Redirect>}
              </Route>

              <Route path={`${lan}/account/:`}>
                {<Redirect to={`${lan}/account`} ></Redirect>}
              </Route>
              <Route path={`${lan}/donate`/** */}>
                <DonateHome user={user} />
              </Route>
              <Route exact path={`${lan}/charities`}>
                <Organizations />
              </Route>

              <Route path={`${lan}/charities/:id`}>
                <Orgdetail user={user} />
              </Route>

              <Route path={`${lan}/fundraise`}>
                <FundraiseHome user={user} />
              </Route>
              <Route path={`${lan}/giftcard`}>
                <GiftCardHome user={user} />
              </Route>

              <Route path={`${lan}/fundraisers/:id`}>
                <FundraiserDetail user={user} />
              </Route>

              {/*<Route path={`${lan}/fundraisers/edit/:id`}>
                  <FundraiseEdit />
                </Route>*/}

              <Route path={`${lan}/signin`} exact>
                <Signin user={user} refresh={refresh} singIn={signIn} />
              </Route>

              <Route path={`${lan}/signup`} exact>
                <Signup user={user} />
              </Route>

              <Route path={`${lan}/password_reset`} exact>
                <InitPsReset user={user} refresh={refresh} singIn={signIn} />
              </Route>

              <Route path={`${lan}/set_new_password`}>
                <NewPs user={user} refresh={refresh} singIn={signIn} />
              </Route>

              <Route exact path={`${lan}/articles`}>
                <AllNews></AllNews>
              </Route>
              <Route exact path={`${lan}/articles/:id`}>
                <News></News>
              </Route>

              <Route exact path={`${lan}/privacy_policy`}>
                <ConfidentialPol user={user} />
              </Route>

              <Route exact path={`${lan}/impressum`}>
                <LegalNotice user={user} />
              </Route>

              <Route exact path={`${lan}/terms_of_use`}>
                <UserTermsP user={user} />
              </Route>

              <Route exact path={`${lan}/faq`}>
                <Faq user={user} />
              </Route>

              <Route exact path={`${lan}/payment_failure`}>
                <TransactionFailure />
              </Route>

              <Route exact path={`/payment_failure`}>
                <Redirect to={`${lan}/payment_failure`} />
              </Route>

              <Route exact path={`${lan}/payment_success`}>
                <TransactionSuccess />
              </Route>

              <Route exact path={`/payment_success`}>
                <Redirect to={`${lan}/payment_success`} />
              </Route>

              <Route exact path={`${lan}/support_us`}>
                <SwFundraiser user={user} lan={lan} />
              </Route>

              <Route exact path={`${lan}/support_us_donate`}>
                <SwFundraiserDonateStart user={user} lan={lan} />
              </Route>

              <Route exact path={`${lan}/support_us_transfer`}>
                <SwFundraiserCreditPay />
              </Route>

              <Route path={`${lan}/notfound`}>
                <NotFoundPage></NotFoundPage>
              </Route>

              <Route component={NotFoundPage} />

            </IonRouterOutlet>
          </IonPage>
        }
      </IonReactRouter>
      <IonPopover side="bottom" alignment="start" trigger='popupTriggerRef' reference='trigger' className='loggedOut' ref={popover} isOpen={popoverOpen} backdropDismiss={false}>
        <IonContent>
          <div className='ion-padding'>

            <h4>{siteText.autologgedOutTitle}</h4>
            <p>{siteText.autologgedOutBody}</p>
            <IonButton onClick={e => setPopoverOpen(false)}>Ok</IonButton>
          </div>

        </IonContent>
      </IonPopover>
      

    </IonApp>
  );
};

export default App;
